import {IAuthUserData, IAuthUserPermission} from "@/store/modules/authModule";
import {EUserPermissions} from "@/model/EUserPermissions";

export class PermissionHelper {

  public static readonly ROLE_ADMINISTRATOR = 'role_administator';
  public static readonly ROLE_DRIVER = 'role_driver';
  public static readonly ROLE_CHANNEL_ADMINISTRATOR = 'role_channel_administrator';
  public static readonly ROLE_SERVICE_PROVIDER_OWNER = 'role_service_provider_owner';
  public static readonly ROLE_USER_CLIENT = 'role_user_client';
  public static readonly ROLE_LOCKER_OWNER = 'role_locker_owner';
  public static readonly ROLE_SERVICE_PROVIDER_OPERATOR = 'role_service_provider_operator';
  public static readonly ROLE_MARKETING = 'role_marketing';
  public static readonly ROLE_PRODUCT = 'role_product';
  public static readonly ROLE_OPERATIONS = 'role_operations';

  public static hasRoleAdministrator(userData: IAuthUserData)
  {
    return userData.role === this.ROLE_ADMINISTRATOR;
  }

  public static hasPermission(userData: IAuthUserData, permission: number, targetId: number) {
    const permissions = userData.permissions;

    let hasPermission: boolean = false;
    if (permissions) {
      permissions.forEach((eachPermission: IAuthUserPermission) => {
        hasPermission = hasPermission || eachPermission.permission === permission &&
          (eachPermission.target_id === targetId || eachPermission.target_id == 0);
      });
    }

    return hasPermission;

  }

  public static hasPermissionAny(userData: IAuthUserData, permission: number) {
    const permissions = userData.permissions;

    let hasPermission: boolean = false;
    if (permissions) {
      permissions.forEach((eachPermission: IAuthUserPermission) => {
        hasPermission = hasPermission || eachPermission.permission === permission;
      });
    }

    return hasPermission;

  }

  public static canViewSubscriptions(userData: IAuthUserData | null) {
    if (!userData || !userData.id) {
      return false;
    }
    return this.hasPermissionAny(userData, EUserPermissions.PERMISSION_DEVELOPER)
      || this.hasPermissionAny(userData, EUserPermissions.PERMISSION_ADMINISTRATOR)
      || this.hasPermissionAny(userData, EUserPermissions.PERMISSION_OPERATIONS);
  }

}
